import React from 'react';
import { css } from '@emotion/core';
import { Flex } from '@rebass/emotion';
import { rem } from '../../utils';

const Section = props => <Flex {...props} py={ [ rem(80)] } width={1} />;

export default Section;
